export default "__VITE_ASSET__DUHqBs3C__"